/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { PropsWithChildren } from 'react'
import styles from './ErrorBoundary.module.css'
import { logWarning } from 'shared-code/log'

interface ErrorBoundaryProps {
  fallback?: React.ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  PropsWithChildren<ErrorBoundaryProps>,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: any, errorInfo: any): any {
    // You can also log the error to an error reporting service
    logWarning(error, errorInfo)
  }

  render(): any {
    if (this.state.hasError) {
      return this.props.fallback ?? <div className={styles.container}>{'Something went wrong'}</div>
    }

    return this.props.children
  }
}

export default ErrorBoundary
